import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { RecruiterHeader } from "../components/Shared/RecruiterHeader";
import { StyleContext } from "../providers/StyleContextProvider";
import { useMediaQuery } from "react-responsive";
import { useAlert } from "../hooks/useAlert";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Button } from "../components/Shared/Buttons/Button";
import { ReactComponent as LeftArrow } from "../assets/svg/left_arrow.svg";
import { ReactComponent as HeaderMobile } from "../assets/svg/short-building.svg";
import { ReactComponent as HeaderDesktop } from "../assets/svg/long-bulding.svg";
import { ReactComponent as StartCurve } from '../assets/svg/header-start-curve.svg';
import { ReactComponent as EndCurve } from '../assets/svg/header-end-curve.svg';
import { Transition } from "../components/Shared/Transition";
import { Login } from "../components/RecruiterLogin/Login";
import { Footer } from "../components/Shared/Footer";
import { AuthContext } from "../providers/AuthContextProvider";
import { LoggedRecruiter } from "../models/LoggedRecruiter";
import { Register } from "../components/RecruiterLogin/Register";
import { LostPassword } from "../components/RecruiterLogin/LostPassword";
import { ResetPassword } from "../components/RecruiterLogin/ResetPassword";
import { LoggedCandidate } from "../models/LoggedCandidate";
import { postCandidateLogout } from "../services/CandidateService";

export const RecruiterLoginRegisterPage: React.FC = () => {
    let params = useParams();
    const styleContext = useContext(StyleContext);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const candidate: LoggedCandidate | null = authContext.getLoggedCandidate();
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("recruiterLoginRegister"));
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" });
    const callbackUrl: string | null = searchParams.get("callbackUrl");
    const message: string | null = searchParams.get("message");
    const { Alert, openAlert } = useAlert();
    const navigate = useNavigate();
    const stage = params.stage ? params.stage : "login";

    useEffect(() => {    
        setStyles(styleContext.getComponentStyle("recruiterLoginRegister"));
    }, [isMobile]);

    useEffect(() => {    
        if(recruiter !== null) {        
            navigate("/recruiter/vacancy");
        }
        else if (candidate !== null) {
            localStorage.removeItem("candidate");
            localStorage.removeItem("savedJobIds");
            localStorage.removeItem("token");
            postCandidateLogout(candidate!.candidateId);
        }
    }, []);

    const handleChangeState = (stage: string) => {
        if(callbackUrl !== null) {
          searchParams.set("callbackUrl", callbackUrl);
        }
        if(message !== null) {
          searchParams.set("message", message);
        }
        navigate("/recruiter/account/" + stage + `?${searchParams}`);
    }

    return (
        <>
            <Helmet><title>Recruiter Account - XpressJobs</title></Helmet>
            <RecruiterHeader recruiterLoginEnable={false}/>
            <div 
                style={{
                    ...styles.header, 
                    ...(stage === "register" && styles.header.register), 
                    ...(message && stage==="login" && styles.header.messgeEnabledLogin), 
                    ...(message && stage==="register" && styles.header.messageEnabledRegister)
                }}
            >     
                <hr style={styles.header.line}/>              
                <Button style={styles.header.backButton} onClick={() => navigate(-1)}><LeftArrow style={styles.header.backButton.icon}/></Button> 
                {isMobile ? <HeaderMobile style={styles.header.backgroundSvg}/> : <HeaderDesktop style={styles.header.backgroundSvg}/>}
                <div style={{...styles.recruitersSvg, ...(stage === "register" && styles.recruitersSvg.register)}}/>
                <StartCurve style={styles.startCurve}/>
                <EndCurve style={styles.endCurve}/>
            </div>
            <div style={styles.mainWrapper}>
            {stage === "login" && <Transition>
                <Login styles={styles} callbackUrl={callbackUrl} message={message} title={isMobile ? "Login" : "Recruiter Login"} openAlert={openAlert} changeStage={handleChangeState}/> 
            </Transition>}
            {stage === "register" && <Transition>
                <Register styles={styles} callbackUrl={callbackUrl} message={message} title={isMobile ? "Register" : "Recruiter Register"} openAlert={openAlert} changeStage={handleChangeState}/>
            </Transition>}
            {stage === "lostPassword" && <Transition>
                <LostPassword styles={styles} openAlert={openAlert}/>
            </Transition>}
            {stage === "resetPassword" && <Transition>
                <ResetPassword styles={styles} id={searchParams.get("id")!} token={searchParams.get("token")!} openAlert={openAlert} />
            </Transition>}
            </div>
            <Footer/>
            <Alert />
        </>
    )
}